function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-(BeComfort/BeEnergy)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1440px---Balance-home---Stroom",
  transform: "translate(-1239.000000, -625.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Laatste-meldingen",
  transform: "translate(120.000000, 534.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Schoonmaak-status/klaar",
  transform: "translate(1119.000000, 91.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Asset-klaar"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-4",
  fill: "#D3D3D3",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,8.93416331 L8.9957757,12.5333333 C10.7941688,10.0201853 12.4622436,8.24240748 14,7.2",
  id: "Path-2-Copy",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))))));
function SvgGreyCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5B8FEE52-DA31-432F-806F-6A0A5B66A7B7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCheckmark);
export default __webpack_public_path__ + "static/media/Grey_checkmark.e7a044fca9f0e1aec81d94904ce9d202.svg";
export { ForwardRef as ReactComponent };